import React from 'react'

import { func, string } from 'prop-types'

import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'

import FilterChip from '../../../Shared/FilterChip/FilterChip'

// Extracted so each chip subscribes only to the slice it cares about - sibling
// toggles don't trigger this row's re-render.
function PrintAttributesChip({ chipKey, select, onChange }) {
  const translate = useTranslate()

  const isChecked = useSearchPageStore(select)

  return (
    <FilterChip
      id={`print-attr-${chipKey}`}
      label={translate(`search_page.filters.print_attributes.${chipKey}`)}
      isChecked={isChecked}
      onChange={onChange}
    />
  )
}

PrintAttributesChip.propTypes = {
  chipKey: string.isRequired,
  select: func.isRequired,
  onChange: func.isRequired,
}

export default PrintAttributesChip
